export default {
    selectedVideo: { tracks: [], parent: { title: "", covers: {} } },
    mostViewed: []
}